import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { NavLink } from "react-router-dom";

const InternalNavLink = ({ className, ...props }) => (
  <NavLink className={classNames("nav-link", className)} {...props} />
);

InternalNavLink.propTypes = {
  className: PropTypes.string
};

InternalNavLink.defaultProps = {
  className: ""
};

export default InternalNavLink;
